import { useState, useEffect, useCallback } from 'react'
import { fetchStoryHistory, saveStoryHistory, deleteStoryHistory, type SaveStoryPayload } from '../api/storyWriterApi'
import type { StoryHistoryItem } from '../types'

export function useStoryHistory() {
  const [history, setHistory] = useState<StoryHistoryItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const items = await fetchStoryHistory()
      setHistory(items)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load history')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  const save = useCallback(async (payload: SaveStoryPayload) => {
    console.log('[StoryHistory] Saving story')
    const item = await saveStoryHistory(payload)
    console.log('[StoryHistory] Saved', { id: item.id })
    setHistory((prev) => [item, ...prev])
    return item
  }, [])

  const remove = useCallback(async (id: string) => {
    console.log('[StoryHistory] Deleting', { id })
    await deleteStoryHistory(id)
    setHistory((prev) => prev.filter((item) => item.id !== id))
  }, [])

  return { history, loading, error, save, remove, reload: load }
}
